import { render, staticRenderFns } from "./LoadingFancy.vue?vue&type=template&id=5ceb958b&"
import script from "./LoadingFancy.vue?vue&type=script&lang=js&"
export * from "./LoadingFancy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports